import React, { useState } from 'react';

export const AnamneseGenerator = () => {
  const [text, setText] = useState('');
  const [anamnese, setAnamnese] = useState('');
  const [loading, setLoading] = useState(false);

  const generate = async () => {
    if (!text) return;
    setLoading(true);
    const prompt = `Baseado no texto abaixo gere uma ANAMNESE médica estruturada:\n\n${text}`;
    try {
      const res = await fetch('https://openrouter.ai/api/v1/chat/completions', {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${process.env.REACT_APP_OPENROUTER_API_KEY}`,
          'Content-Type': 'application/json',
          'HTTP-Referer': window.location.origin,
        },
        body: JSON.stringify({
          model: 'deepseek/deepseek-chat',
          messages: [{ role: 'user', content: prompt }],
          max_tokens: 1200,
        }),
      });
      const data = await res.json();
      setAnamnese(data.choices[0].message.content);
    } catch (err) {
      alert('Erro IA: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="tool">
      <h2>Gerador de Anamnese IA</h2>
      <textarea placeholder="Cole texto ou resultado de OCR" rows={6} value={text} onChange={e => setText(e.target.value)} />
      <button onClick={generate} disabled={loading}>
        {loading ? 'Gerando...' : 'Gerar Anamnese'}
      </button>
      {anamnese && <pre className="result">{anamnese}</pre>}
    </div>
  );
};
